export let privacyLink = "U_P5ic";
export default {privacyLink};